import { render } from "./ExternalAssetsView.vue?vue&type=template&id=0d095904&scoped=true"
import script from "./ExternalAssetsView.vue?vue&type=script&lang=js"
export * from "./ExternalAssetsView.vue?vue&type=script&lang=js"

import "./ExternalAssetsView.vue?vue&type=style&index=0&id=0d095904&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d095904"]])

export default __exports__